<div class="compliance-status">
  <div class="compliance-status__title">
    <h2>Compliance status</h2>
  </div>
  <div class="compliance-status__statuses__wrapper" data-qa="statuses">
    <div
      (click)="onStatusClick($event)"
      (keydown)="onStatusClick($event)"
      *ngFor="let status of statuses"
      class="compliance-status__statuses__counter"
      tabindex="0"
    >
      <div
        [ngClass]="status.iconColor"
        class="compliance-status__statuses__counter__icon"
        data-qa="statusIcon"
      >
        <ui-svg-icon
          [iconClassName]="status.iconClassName"
          [svgId]="status.icon"
        ></ui-svg-icon>
      </div>
      <div
        class="compliance-status__statuses__counter__text"
        data-qa="statusText"
      >
        {{ status.text }}
      </div>
      <div
        class="compliance-status__statuses__counter__counter"
        data-qa="statusCounter"
      >
        {{ status.counter }}
      </div>
    </div>
  </div>
  <div class="compliance-status__expire-information">
    <h2 class="compliance-status__expire-information__title">
      Compliance status
    </h2>
    <span class="compliance-status__expire-information__content">
      <span>
        Your compliance is due to expire on
        <span
          class="compliance-status__expire-information__content__date"
          data-qa="expiryDate"
        >
          {{ expiryDate | date: 'dd/MM/YYYY' }}
        </span>
      </span>
    </span>
    <br />
    <span class="compliance-status__expire-information__content font-bold">
      <ng-container *ngIf="statuses | isExpiredDocument; else isNotExpired">
        You must update it as soon as possible to continue working with us!
      </ng-container>
      <ng-template #isNotExpired>
        Update your compliance before it expires to ensure you can continue to
        work with us!
      </ng-template>
    </span>
    <ng-container *ngIf="isNotCompliancePage">
      <br />
      <span class="compliance-status__expire-information__content">
        <a
          class="compliance-status__expire-information__content__link"
          routerLink="/compliance"
          >Update Now<span
            class="compliance-status__expire-information__content__link__chevron"
          ></span
        ></a>
      </span>
    </ng-container>
  </div>
</div>
